import { useEffect, useRef } from 'react';

import { initAmplitudeAnalytics } from './initAmplitudeAnalytics';

export const AnalyticsLoader = () => {
  const ran = useRef(false);
  const ANALYTICS_ID = import.meta.env.VITE_AMPLITUDE_ANALYTICS as string | undefined;

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    initAmplitudeAnalytics(ANALYTICS_ID);
  }, [ANALYTICS_ID]);

  return null;
};
